const ComponentType = {
  Text: 14,
  List: 15,
  Carousel: 17,
  Form: 16
};

Object.freeze(ComponentType)

export default ComponentType
